import {CardContent} from '@mui/material';
import React, {FunctionComponent, useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import NoSubscriptionBlock from '../../../../components/Blocks/NoSubscriptionBlock/NoSubscriptionBlock';
import BackButton from '../../../../components/Buttons/BackButton';
import EditSelectionButton from '../../../../components/Buttons/EditSelectionButton';
import {Button, Card, FormControl, TextField} from '../../../../components/StyledComponents';
import {EPlatformsNames, ESubscriptionPlans, ETrialStatus} from '../../../../models/consts';
import {IGitlabUserAddEditProps} from '../../../../models/inner-models';
import {useAppSelector} from '../../../../store/hooks';
import {trelloTrialStatus} from '../../../../store/selectors';
import './style.scss';
import Platform from "../../../../models/platforms-data";
import {EXTENSION_URL} from "../../../../constants";
import {expIcon} from "../../../../assets/icons/icons";
import ExtensionModal from "../../../../components/Dialogs/ExtensionModal";

const ChatUserAddEdit: FunctionComponent<IGitlabUserAddEditProps> = ({
                                                                       user,
                                                                       subPlan,
                                                                       onClose
                                                                     }: IGitlabUserAddEditProps) => {
    const {t: translate} = useTranslation();
    const trialState = useAppSelector(trelloTrialStatus);
    const [open, setOpen] = useState(false);

    const {register, setValue, trigger, reset} = useForm({
      mode: 'onChange',
    });

    useEffect(() => {
      reset();
      register('username', {
        required: translate('forms.common.required') as string,
        minLength: {
          value: 2,
          message: translate('forms.common.min_length'),
        },
      });
    }, [register]);

    useEffect(() => {
      if (user) {
        setValue('username', user.username);
        trigger(['username']);
      }
    }, [user]);

    return (
      <>
        {subPlan?.type === ESubscriptionPlans.NO_SUB && trialState === ETrialStatus.NOT_STARTED ?
          <NoSubscriptionBlock platformName={EPlatformsNames.CHATGPT}/>
          :
          <Card mb={6}>
            <CardContent>
              <p className='newapp-step-two-auth-title'>
                Authorize BackupLABS
              </p>
              <div className='newapp-step-two-log'>
                <p className='newapp-step-two-title'>
                  Connecting to {Platform.chatgpt.title}
                </p>
                <div className='newapp-step-two-app-row'>
                  <div className='newapp-step-two-app'>
                    <div className='platformLogoContainer'>
                      <img className="platformLogo" src={Platform.chatgpt.smallLogo} loading="lazy"/>
                    </div>
                    <p className='newapp-step-two-app-title'>
                      {Platform.chatgpt.title}
                    </p>
                  </div>
                  {onClose && (
                    <EditSelectionButton onClick={onClose}/>
                  )}
                </div>
              </div>
              <p className='newapp-step-two-desc'>
                {translate('forms.common.platform_auth_desc_first')}
                <br/>
                {translate('forms.common.platform_auth_desc_second', {platform: Platform.chatgpt.title})}
              </p>
              <div id="gitlab-add-user-description">
                {user && user?.username && <div className="form-row">
                  <FormControl className="input-name">
                    <TextField
                      required
                      id="user-name"
                      name="username"
                      placeholder={translate('forms.chatgpt_add_edit_user.account_name')}
                      defaultValue={user?.username || ''}
                      disabled={true}
                    />
                  </FormControl>
                </div>
                }
                <div className="add-change-user">
                  {onClose && (
                    <BackButton onClick={onClose}/>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setOpen(true)}
                  >
                    <span>Set up connection</span>
                    <img src={expIcon} className="feather-icon-in-button icon-ml"/>
                  </Button>
                </div>
              </div>
              {open && <ExtensionModal onClose={() => setOpen(false)} platform='chatgpt'/>}
            </CardContent>
          </Card>
        }
      </>
    );
  }
;

export default ChatUserAddEdit;
